// src/components/PollWhileUnverified.tsx
import React from "react";
import { useEmailVerificationPoll } from "../hooks/useEmailVerificationPoll";

export default function PollWhileUnverified() {
    const { startAutoPoll, stopPoll } = useEmailVerificationPoll();
    React.useEffect(() => {
        startAutoPoll(120000, 4000);  // 2 min, var 4:e sekund
        return () => stopPoll();      // städa timers om grenen lämnas
    }, [startAutoPoll, stopPoll]);
    return null;
}